<div class="z-fx-col z-fx-gap-24 wrapper">
  <h2>zeff-icons-free</h2>

  <div class="grid-4 grid">
    @for (icon of iconsFree; track icon) {
      <div class="z-fx z-fx-between-center z-fx-gap-8 icon">
        <mat-icon fontSet="zefplayer">{{ icon.ligatures }}</mat-icon>
        <span class="zef-text-p1 zef-text-align-right">{{ icon.name }}</span>
      </div>
    }
  </div>

  <h2>zeff-icons-full</h2>

  <div class="grid-4 grid">
    @for (icon of iconsFull; track icon) {
      <div class="z-fx z-fx-between-center z-fx-gap-8 icon">
        <mat-icon>{{ icon.ligatures }}</mat-icon>
        <span class="zef-text-p1 zef-text-align-right">{{ icon.name }}</span>
      </div>
    }
  </div>
</div>
